import React from 'react';
export function SubscriberAddIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.745 12.314A5 5 0 0015 9V7A5 5 0 005 7v2a5 5 0 001.259 3.313A5.007 5.007 0 003 17v3a2 2 0 002 2h10a2 2 0 002-2v-3a5.01 5.01 0 00-3.255-4.686zM15 20H5v-3a3 3 0 013-3 1 1 0 001-1v-.54a1 1 0 00-.5-.867A3 3 0 017 9V7a3 3 0 116 0v2a3 3 0 01-.863 2.108c-.189.186-.4.348-.63.482a1 1 0 00-.507.87V13a1 1 0 001 1 3 3 0 013 3v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2z"
  }));
}